import { useCallback } from "react";
import { ConversionAnalyticsEvents } from "@pexip-engage-public/plugin-events";
import type { ActionFunctionArgs } from "@remix-run/node";
import { useParams } from "@remix-run/react";

import { useSessionIdHeader } from "~/hooks/useFetch";
import { useStateManager } from "~/modules/StateManager.hooks";
import { createServerStateManager } from "~/modules/StateManager.server";

export async function action(args: ActionFunctionArgs) {
  const stateManager = await createServerStateManager(args);
  const data = await args.request.json();
  const eventData = typeof data === "object" && data && "event" in data && data.event;

  if (!eventData) return;
  stateManager.dispatchCAEvent(eventData as any);

  return null;
}

const HEADERS = {
  headers: {
    "Content-Type": "application/json",
  },
};

export function useSendCAEvent() {
  const { enterprise } = useParams<"enterprise">();
  const stateManager = useStateManager();

  const disableAnalytics = stateManager.state.config.session.status === "disabled";

  const headers = useSessionIdHeader(HEADERS);

  return useCallback(
    <T extends ConversionAnalyticsEvents>(event: T) => {
      if (!enterprise || disableAnalytics) return;
      const url = `/api/enterprises/${enterprise}/session-events`;

      void fetch(url, {
        body: JSON.stringify({ event }),
        headers,
        method: "POST",
        keepalive: true,
      });
    },
    [enterprise, disableAnalytics, headers],
  );
}
